<template>
  <div class='panel'>
    <div ref='settings' class='panel__item panel__item--settings js-settings'>
      <div class='settings__item'>
        Zoom: {{ zoom }}<br>
        <input
          v-model='zoom'
          type='range'
          class='input js-input'
          :min='zoomMin'
          max='10'
          step='0.05'
          value='1'
        >
      </div>
      <div ref='canvasContainer' class='canvas-container'>
        <canvas ref='canvasOverview' class='canvas js-canvas-overview'></canvas>
      </div>
      <RemovePanel :panel="panel" />
    </div>
    <div class='panel__item'>
      <div ref='canvasMainContainer' class='canvas-container-main'>
        <canvas ref='canvasMain' class='canvas canvas-main js-canvas-main'></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import panelController from '../controllers/panel';
import RemovePanel from './RemovePanel.vue';

export default {
  name: 'Panel',
  components: { RemovePanel },
  props: ['panel'],
  computed: {
    zoom: {
      get() {
        return this.panel.zoom;
      },
      set(value) {
        this.$store.dispatch('setPanelZoom', {
          panel: this.panel,
          value,
        });
      },
    },
    zoomMin() {
      return this.panel.minZoom;
    },
  },
  mounted() {
    panelController.init(this.panel, this.$refs);
  },
};
</script>

<style scoped lang='scss'>
  @import '../styles/variables';

  .panel {
    display: flex;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin: $spacing;
    background-color: $backgroundColor;
  }

  .panel__item {
    padding: $spacing;

    &--settings {
      width: 180px;
      border-right: 1px solid #ccc;
    }

    .canvas {
      border: 1px solid #000;
      margin: auto;
    }
  }

  .canvas-container {
    display: flex;
    width: 150px;
    height: 150px;
  }

  .canvas-container-main {
    display: flex;
    width: 500px;
    height: 250px;
  }

  .canvas-main {
    cursor: grab;

    &:hover:active {
      cursor: grabbing;
    }
  }
</style>
